import React from 'react';
import TestimonialCard from '../../components/Testimonial/TestimonialCard ';
import imgSatyam from '../../assets/images/testimonial/satyam.png';
import imgSavaliya from '../../assets/images/testimonial/savaliya.jpg';
import HarbertSpin from '../../assets/images/testimonial/brand-1-7.jpg';
// import MaintoVula from '../../assets/images/testimonial/testimonial-1-4.jpg';
// import NafizBhuiyan2 from '../../assets/images/testimonial/testimonial-1-1.jpg';
// import RobertSon2 from '../../assets/images/testimonial/testimonial-1-2.jpg';
const TestimonialsMain = () => {
    const testimonials = [
        {
            imageUrl: imgSatyam,
            clientName: 'Satyam Developers',
            clientTitle: 'Shraddha Residency',
            rating: 5,
            testimonialText: 'ArchElevators Pvt. Ltd. brought exceptional value to our Residential Elevators project. Their ability to step in during a demanding phase and align quickly with project expectations made a noticeable difference. The team delivered reliable solutions across planning, execution, and final delivery, earning appreciation from our internal team, technical consultants, and the client. Their commitment to quality and smooth coordination made the collaboration highly successful. We anticipate continued collaboration with ArchElevators.',
        },
        {
            imageUrl: imgSavaliya,
            clientName: 'Savaliya Builders',
            clientTitle: 'Sun Gold',
            rating: 5,
            testimonialText: 'ArchElevators played a key role in the successful execution of our Elevators project. Despite joining during a high-pressure phase, their team demonstrated a strong understanding of project requirements and delivered meaningful input throughout the design, configuration, and completion stages. Their professionalism, technical capability, and focus on quality were consistently acknowledged by the client, internal teams, and technical partners. We appreciate their contribution and look forward to future collaborations with ArchElevators.',
        },
        {
            imageUrl: HarbertSpin,
            clientName: 'Stavya Spine Hospital',
            clientTitle: '',
            rating: 5,
            testimonialText: 'Working with ArchElevators was a seamless experience throughout our Elevators project. The team demonstrated clarity in understanding requirements, proactive involvement in design and configuration, and consistent attention during execution. Their disciplined approach, technical knowledge, and dependable delivery were well recognized by all stakeholders. We value their contribution and would gladly partner with ArchElevators again on future developments.',
        },
        {
            imageUrl: "",
            clientName: 'Seven Star Real Estate Developers',
            clientTitle: 'Platinum gold',
            rating: 5,
            testimonialText: 'We sincerely thank ArchElevators for their outstanding contribution to the Elevators project. Their technical expertise, attention to detail, and ability to deliver quality results under critical timelines were highly valued. We appreciate their efforts and look forward to working with ArchElevators again.',
        },
        {
            imageUrl: "",
            clientName: 'Mr. Kaushalbhai Trivedi',
            clientTitle: 'Private Residence',
            rating: 5,
            testimonialText: 'We recently got this lift installed at our residence, and we are extremely happy with the result. The lift runs very smoothly, is quiet in operation, and feels safe and reliable. The installation team was professional, punctual, and completed the work with great attention to detail. The overall quality, finish, and performance have exceeded our expectations. It has added both convenience and value to our home. Highly recommended for anyone looking for a premium home lift solution.',
        },
        {
            imageUrl: "",
            clientName: 'Dr. Bhatia',
            clientTitle: 'Private Residence',
            rating: 5,
            testimonialText: 'I am Dr Bhatia, a retired Govt. office aged 72  having difficulty in walking and climbing stairs. My wife also have knee joint problems. Finally in 2018 got a lift of Kumar Elevators  installed in our home. I found the team highly efficient.They managed the needful done with practically not making any kind of alteration in my existing buiding structure.The excellent quality of materials used by them.All safety and security measures were strictly taken care of.Design of cabin is beautiful.The work was completed in very short duration and timely.The total cost was also very reasonable and less than that of other agencies. After the installation, they are maintaining and servicing my unit regularly till today.The service maintenance quality is excellent and quick at highly reasonable price. I am very happy to have and enjoy using ARCH Elevators(Lift) at my home',
        },

        // {
        //     imageUrl: NafizBhuiyan2,
        //     clientName: 'Nafiz Bhuiyan',
        //     clientTitle: 'Manager',
        //     rating: 5,
        //     testimonialText: 'Logistic service involves the planning, implementation, and control of the efficient and effective movement and storage of goods and materials.',
        // },
        // {
        //     imageUrl: RobertSon2,
        //     clientName: 'Robert Son',
        //     clientTitle: 'Manager',
        //     rating: 5,
        //     testimonialText: 'Logistic service involves the planning, implementation, and control of the efficient and effective movement and storage of goods and materials.',
        // },
        // Add more testimonials as needed
    ];

    return (
        <section className="testimonials-page">
            <div className="container">
                <div className="row">
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard
                            key={index}
                            imageUrl={testimonial.imageUrl}
                            clientName={testimonial.clientName}
                            clientTitle={testimonial.clientTitle}
                            rating={testimonial.rating}
                            testimonialText={testimonial.testimonialText}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsMain;
